import React, { useEffect, useContext, useState } from 'react'
import UnmovingProductsHeader from './UnmovingProductsHeader'
import UnmovingProductsInner from './UnmovingProductsInner'
import UnmovingProductsFooter from './UnmovingProductsFooter'
import { appContext } from '../../../../../../App'
import { getUnmovingProductsReport } from '../../../../ReportsFunctions'

export const unmovingProductsContext = React.createContext()

function useUnmovingProductsController(props) {
  const app = useContext(appContext)
  const [date, setDate] = useState({
    from: new Date(app.getClientDateTime()).getFullYear() + '-01-01',
    to: new Date(app.getClientDateTime()).getFullYear() + '-12-31'
  })

  const [unmovingProducts, setUnmovingProducts] = useState(null)

  
  useEffect(() => {
    const init = async () => { setUnmovingProducts(await getUnmovingProductsReport(app, date)) }
    init()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date])

  return ({
    app,
    unmovingProducts: [unmovingProducts, setUnmovingProducts],
    date: [date, setDate]
  })
}

function UnmovingProductsController(props) {
  const unmovingProductsController = useUnmovingProductsController(props)
  return (
    <React.Fragment>
      <unmovingProductsContext.Provider value={unmovingProductsController}>
        <UnmovingProductsHeader />
        <UnmovingProductsInner />
        <UnmovingProductsFooter />
      </unmovingProductsContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(UnmovingProductsController)